import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { loadMessages } from 'devextreme/localization';
import { TranslateService } from '@ngx-translate/core';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { CheckValidation } from 'src/app/shared/services/hr/CheckValidation.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'app-public-holiday',
  templateUrl: './public-holiday.component.html',
  styleUrls: ['./public-holiday.component.scss'],
  providers: [DatePipe]
})
export class PublicHolidayComponent implements OnInit {
  fromdate = new Date;
  button = {}
  customDataSource: any;
  date = new Date()
  addpopup: string = ''
  LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
  currentLang: any;
  @ViewChild(DxDataGridComponent) grid: DxDataGridComponent;

  constructor(public gt: genericCustomStoreService, public DatePipe: DatePipe, public translate: TranslateService,
    private validation: CheckValidation, public Objects: ObjectsService) {
    gt.seturl("PublicHoliday");
    gt.submit();
    this.customDataSource = gt.customDataSource;
    this.button = Objects.button;
    this.validateAsync = this.validateAsync.bind(this);
    this.validateAsyncForEn=this.validateAsyncForEn.bind(this)
    this.setCellValuedaycount = this.setCellValuedaycount.bind(this)
    this.setCellfromdate = this.setCellfromdate.bind(this)
    this.currentLang = localStorage.getItem(
      this.LOCALIZATION_LOCAL_STORAGE_KEY
    );

    loadMessages({
      en: { "Yes": this.translate.instant('personal.yes'), "No": this.translate.instant('personal.no') }
  });

  }
  ngOnInit(): void {
  }
  validateAsync(params: any) {
    var id = params.data.id ?? 0;
    return this.validation.asyncCheckNameValue(params.value, id, "PublicHoliday");
  }

  validateAsyncForEn(params: any) {
    var id = params.data.id ?? 0;
    return this.validation.asyncCheckNameValue(params.value, id, "PublicHoliday",'CheckName','NameEn');
  }

  updateRow(options: any) {
    options.newData = Object.assign(options.oldData, options.newData);
    options.newData.dateOfRegistration = this.date
  }
  onInitNewRow(e: any) {
    e.data.dateOfRegistration = this.date
    this.addpopup = this.translate.instant('tableinfo.addbutton')
  }
  onEditingStart() {
    this.addpopup = this.translate.instant('tableinfo.editbutton')

  }
  onEditorPreparing(e: any) {
    this.gt.onEditorPreparing(e)
  }
  addrowfun(name: string) {
    return this.gt.addrow(name)
  }


  setCellValuedaycount(newData: any, value: any, oldData: any) {
    newData.dayCount = value;
    let from = new Date(oldData.fromDate).getTime();
    from = from + (value * (86400000))
    newData.toDate = this.DatePipe.transform(from)
  }
  setCellfromdate(newData: any, value: any, oldData: any) {
    newData.fromDate = value;
    console.log(oldData.dayCount);
    if (oldData.dayCount) {
      let from = value.getTime();
      from = from + (oldData.dayCount * (86400000))
      newData.toDate = this.DatePipe.transform(from)
    }

  }

}
